import React, { useState, useEffect } from "react"
import { styled } from "../../../../stitches.config"

import { withThemeContext } from "../../StitchesThemeProvider";

import Link from "../../../../components/Link"

import AudioBrief from "../AudioBrief"
import { ReactComponent as CategoriesIcon } from "../../../assets/icons/nav/categories-icon.svg?react"
import { ReactComponent as CovidIcon } from "../../../assets/icons/nav/covid-icon.svg?react"
import { ReactComponent as HomeIcon } from "../../../assets/icons/nav/home-icon.svg?react"
import { ReactComponent as PlayIcon } from "../../../assets/icons/nav/play-icon.svg?react"
import { ReactComponent as StarIcon } from "../../../assets/icons/nav/star-fill-icon.svg?react"
import NavMenuMobile from "../NavMenuMobile"
import { useLocation } from "react-router-dom";

interface Props {
    isDarkMode?: boolean;
}

export const Navbar: React.FC<Props> = ({ isDarkMode }) => {
    const [isCategoriesMenuActive, setIsCategoriesMenuActive] = React.useState(false);
    const activeCategoriesMenuHandler = () => setIsCategoriesMenuActive(!isCategoriesMenuActive);
    const firstIconData = window.APP_SETTINGS?.mobile_bottom_icon;
    const lastIconData = window.APP_SETTINGS?.mobile_bottom_icon_last;

    const { pathname } = useLocation();

    const isFirstIconLink = pathname == firstIconData?.link.split('?')[0];
    const isLastIconLink = pathname == lastIconData?.link.split('?')[0];

    const mainDomain = window.APP_SETTINGS.main_domain
    const mainDomainAdress = mainDomain ? `https://${mainDomain}/` : `/`;

    const currentUrl = window.location.origin + window.location.pathname;
    const targetUrl = `https://${mainDomain}/`;
    const isCurrentUrlMainAdress = currentUrl === targetUrl

    return (
        <StyledNavbarBottomWrapper>
            <StyledNavbarBottom>
                {firstIconData?.link &&
                    <Link to={firstIconData?.link} data-analytics-name="mobile-nav-1" className={isFirstIconLink ? 'active' : ''}>
                        {firstIconData &&
                            <img
                                src={firstIconData?.icon}
                                alt=""
                                width={24}
                                height={24}
                                style={isDarkMode ? { filter: 'invert(1)' } : { filter: 'invert(0)' }}
                            />
                        }
                        <span>{firstIconData?.name}</span>
                    </Link>
                }
                <div
                    onClick={activeCategoriesMenuHandler}
                    className="categoriesMenu"
                    data-analytics-name="mobile-nav-2"
                >
                    <CategoriesIcon />
                    <span>Kategorie</span>
                </div>
                <div className="home-button">
                    {isCurrentUrlMainAdress ?
                        <a href={mainDomainAdress} data-analytics-name="mobile-nav-3" className={pathname == '/' ? 'active' : ''}>
                            <HomeIconWrapper>
                                <HomeIcon />
                            </HomeIconWrapper>
                            <span>Strona Główna</span>
                        </a>
                        :
                        <Link to={mainDomainAdress} data-analytics-name="mobile-nav-3" className={pathname == '/' ? 'active' : ''}>
                            <HomeIconWrapper>
                                <HomeIcon />
                            </HomeIconWrapper>
                            <span>Strona Główna</span>
                        </Link>
                    }
                </div>
                <HomeIconLayer className="whiteLayer" />
                <Link to="/dla-ciebie" data-analytics-name="mobile-nav-4" className={pathname == '/dla-ciebie' ? 'active' : ''}>
                    <StarIcon />
                    <span>Dla Ciebie</span>
                </Link>
                {(lastIconData?.link) ? (
                    <Link to={lastIconData?.link} data-analytics-name="mobile-nav-5" className={isLastIconLink ? 'active' : ''}>
                        {lastIconData &&
                            <img
                                src={lastIconData?.icon}
                                alt=""
                                width={24}
                                height={24}
                                style={isDarkMode ? { filter: 'invert(1)' } : { filter: 'invert(0)' }}
                            />
                        }
                        <span>{lastIconData?.name}</span>
                    </Link>
                ) : (
                    <AudioBrief dataAnalyticsName="mobile-nav-5">
                        {/* <PlayIcon /> */}
                        <span>Audio&nbsp;Brief</span>
                    </AudioBrief>
                )}

            </StyledNavbarBottom>
            {/*<HomeIconLayer />*/}
            <NavMenuMobile
                isMobileMenuActive={isCategoriesMenuActive}
                setIsMobileMenuActive={setIsCategoriesMenuActive}
            />
        </StyledNavbarBottomWrapper>
    );
}

const StyledNavbarBottom = styled('nav', {
    borderTop: "1px solid $grayscale25",
    height: "72px",
    width: "100%",
    background: "$grayscale0",
    display: "flex",
    justifyContent: "space-around",
    margin: 0,
    position: "relative",
    zIndex: 2,
    "& button, a, .categoriesMenu": {
        background: "none",
        width: "78px",
        borderWidth: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        color: "$grayscale100",
        textDecoration: "none",
        paddingTop: "6px",
        "& span": {
            fontFamily: "HK Grotesk",
            fontWeight: "700",
            fontSize: "10px",
            lineHeight: "10px",
            margin: "12px 0 18px 0",
        },
        "& svg": {
            fill: "$grayscale100",
        }
    },

    "& .active": {
        color: "$primary",
        "& svg": {
            fill: "$primary",
        },
        "& img": {
            filter: "$filter-svgPrimary !important"
        }
    },

    "& a": {
        transition: "0s 0.5s",
        "& svg": {
            transition: "0s 0.5s",
        },
        "& div": {
            transition: "0s 0.5s",
        },
    },

    "& a:active": {
        color: "$primary",
        textDecoration: "none",
        transition: "0s",

        "& svg": {
            fill: "$primary",
            transition: "0s",
        },
        "& div": {
            background: "rgba(255, 100, 0, 0.1)",
            transition: "0s",
        },
    },

    "& a:hover": {
        textDecoration: "none",
    },

    "& .whiteLayer": {
        visibility: "hidden",
        transition: "0s 0.5s",
    },

    "& .home-button": {
        position: "relative",
        top: "-13px",
        zIndex: 2,
        transition: "0s 0.5s",

        "& span": {
            marginTop: "3px",
        },
        "& a": {
            paddingTop: "0px",
        },
        "&:active": {
            "& + .whiteLayer": {
                background: "$grayscale0",
                visibility: "visible",
                transition: "0s",
            }
        }
    }
})

const HomeIconWrapper = styled('div', {
    width: "54px",
    height: "54px",
    borderRadius: "50%",
    background: "$grayscale25",
    display: "flex",
    border: "4px solid $grayscale0",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    flexShrink: 0,
})

const HomeIconLayer = styled('div', {
    width: "56px",
    height: "56px",
    borderRadius: "50%",
    background: "$grayscale25",
    position: "absolute",
    top: "-13px",
    left: "calc( 50% - 27.5px )",
    zIndex: 1,
})

const StyledNavbarBottomWrapper = styled('div', {
    position: "relative",
})


export default withThemeContext(Navbar);
